import React, { useEffect, useState } from "react";
import { MdLocationOn, MdEmail, MdPhone } from "react-icons/md";
import { obtenerSettings } from "../api";
import ParticleBackground from "../components/ParticleBackground";

const Contact = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await obtenerSettings();

        // Reparar si viene como iframe completo
        if (data?.address_link?.includes('<iframe')) {
          const match = data.address_link.match(/src="([^"]+)"/);
          data.address_link = match?.[1] || '';
        }

        // Parsear horarios si vienen como string
        if (typeof data?.opening_hours === "string") {
          try {
            data.opening_hours = JSON.parse(data.opening_hours);
          } catch (err) {
            console.error("Error parsing opening_hours JSON:", err);
            data.opening_hours = null;
          }
        }

        setSettings(data);
      } catch (err) {
        console.error("Error loading contact info:", err);
      }
    };
    fetchData();
  }, []);

  const diasOrdenados = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  return (
    <div className="bg-near-black text-light-gray font-inter">
      <style>{`
        h1, h2, h3 {
          font-family: 'Audiowide', sans-serif;
        }
        .bg-near-black { background-color: #141318; }
        .bg-dark-gray { background-color: #1F2937; }
        .bg-mid-gray { background-color: #6A706C; }
        .text-mid-gray { color: #6A706C; }
        .text-blue-gray { color: #566D87; }
        .bg-blue-gray { background-color: #566D87; }
        .border-blue-gray { border-color: #566D87; }
      `}</style>

      <section className="relative py-20 px-6 bg-dark-gray text-center overflow-hidden">
        <ParticleBackground className="opacity-30" />
        <div className="relative">
          <h1 className="text-5xl font-bold mb-4 text-white">Get in Touch</h1>
          <p className="text-mid-gray text-xl max-w-3xl mx-auto">
            Whether you have questions, want to book a private session, or
            celebrate something big — we're here to help you gear up for fun.
          </p>
        </div>
      </section>

      <section className="py-20 px-6">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12">
          <div>
            <h2 className="text-3xl font-bold mb-6 text-white">Our Info</h2>
            <div className="space-y-6 text-lg text-gray-300">
              <div className="flex items-center gap-4">
                <MdLocationOn className="text-3xl text-white" />
                <span>{settings?.address || "Loading address..."}</span>
              </div>
              <div className="flex items-center gap-4">
                <MdPhone className="text-2xl text-white" />
                <span>{settings?.phone || "Loading phone..."}</span>
              </div>
              <div className="flex items-center gap-4">
                <MdEmail className="text-2xl text-white" />
                <span>{settings?.email || "Loading email..."}</span>
              </div>
              <div>
                <h3 className="text-xl font-semibold mt-6 mb-2 text-white">
                  Opening Hours
                </h3>
                {settings?.opening_hours ? (
                  <ul className="text-sm space-y-1">
                    {diasOrdenados.map((day) => {
                      const hours = settings.opening_hours?.[day];
                      const isClosed = hours?.closed === true;

                      return (
                        <li key={day}>
                          {day}:{" "}
                          {isClosed
                            ? "Closed"
                            : `${hours?.open || "--:--"} – ${
                                hours?.close || "--:--"
                              }`}
                        </li>
                      );
                    })}
                  </ul>
                ) : (
                  <p>Loading hours...</p>
                )}
              </div>
            </div>
          </div>

          <div>
            <h2 className="text-3xl font-bold mb-6 text-white">Send Us a Message</h2>
            <form className="space-y-6">
              <input
                type="text"
                placeholder="Your Name"
                className="w-full px-4 py-3 rounded-lg bg-mid-gray text-light-gray placeholder:text-light-gray focus:outline-none"
              />
              <input
                type="email"
                placeholder="Your Email"
                className="w-full px-4 py-3 rounded-lg bg-mid-gray text-light-gray placeholder:text-light-gray focus:outline-none"
              />
              <textarea
                placeholder="Your Message"
                rows="5"
                className="w-full px-4 py-3 rounded-lg bg-mid-gray text-light-gray placeholder:text-light-gray focus:outline-none"
              ></textarea>
              <button
                type="submit"
                className="bg-blue-gray px-6 py-3 rounded-lg text-white hover:bg-mid-gray transition"
              >
                Send Message
              </button>
            </form>
          </div>
        </div>

        {settings?.address_link?.startsWith("https://www.google.com/maps/embed") && (
          <div className="mt-16">
            <h3 className="text-3xl font-bold mb-6 text-white text-center">Find Us on the Map</h3>
            <div className="w-full h-[400px] rounded-lg overflow-hidden border border-blue-gray shadow-md">
  <iframe
    src={settings.address_link}
    className="w-full h-full border-0"
    allowFullScreen=""
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
    title="Lazer Zone Arena Map"
  ></iframe>
</div>

          </div>
        )}
      </section>
    </div>
  );
};

export default Contact;
